<template>
  <div>
    <!-- <offline @detected-condition="handleConnectivityChange">
    </offline> -->
    <template>
      <Navbar></Navbar>
    </template>
    <div class="SelectEstablecimiento">
      <b-form-select
        v-model="selected"
        :options="getSelectEstablecimiento"
        @change="selectChange"
        class="mb-3"
        v-if="getUserInfo"
      />
    </div>
    <div>
      <transition name="fade">
        <router-view></router-view>
      </transition>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import auth from "@/auth/auth";
import Foot from "@/components/pages/template/Foot";
import Navbar from "@/components/pages/template/Navbar";
import offline from 'v-offline';
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'SolicitudModule/getSolicitudField',
  mutationType: 'SolicitudModule/updateSolicitudField',
});

export default {
  name: "app",
  components: {
    Foot,
    Navbar,
    offline
  },
  computed: {
    ...mapGetters([
      "getUserInfo",
      "getSelectEstablecimiento",
      "getEstablecimiento"
    ])
  },
  watch: {
    getEstablecimiento: function(newvalue, oldvalue) {
      console.log(
        "set establecimiento select newvalue oldvalue",
        newvalue,
        oldvalue
      );
      this.selected = newvalue ? newvalue.Id : 0;
      this.setEstablecimientoSolicitud(newvalue);
    }
  },
  data() {
    return {
      user: auth.user,
      selected: 0,
      options: []
    };
  },
  methods: {
    ...mapActions(["setEstablecimiento"]),
    ...mapActions("SolicitudModule",["setFiltroEstablecimiento"]),
    selectChange(value) {
      console.log('selectChange', status);
      if (value) {
        this.setEstablecimiento(value);
      }
    },
    setEstablecimientoSolicitud(establecimiento){
      this.setFiltroEstablecimiento(establecimiento);
    },
    handleConnectivityChange(status) {
      console.log('handleConnectivityChange', status);
      if(!status){
        this.showError("Por favor revise su conexión.");
      }
    }
  },
  mounted(){
    console.log('app mounted', this.getEstablecimiento);
    if(this.getEstablecimiento){
      this.selected = this.getEstablecimiento.Id;
    }
  }
};
</script>

<style>
.SelectEstablecimiento{
  margin: 1rem;
}
.list-group-item {
  border-radius: 2px;
  margin-bottom: 8px;
}
.list-group-item-blue {
  border-radius: 5px;
  margin-bottom: 5px;
}
.display-title {
  font-weight: 700;
  color: rgb(53, 53, 53);
}
.display-name {
  font-weight: 700;
  color: #0f9d58;
}
html,
body {
  height: 100%;
  margin: 0;
}

.swal-button--confirm {
  background-color: #28a745;
}
.swal-button--cancel {
  background-color: rgb(183, 183, 183);
}
.card {
  border-radius: 6px;
  box-shadow: 0 2px 2px hsla(38, 16%, 76%, 0.5);
  color: #252422;
}

.fade-enter-active,
.fade-leave-active {
  transition-property: opacity;
  transition-duration: 0.45s;
}

.fade-enter-active {
  transition-delay: 0.45s;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}
.white {
  background-color: rgb(255, 255, 255);
  padding: 25px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue